// 7タブ・クリエイターパネル共通の小さな純関数（W-E）。判定・整形の本体は lib/giftingRules.ts。ここは表示の橋渡しだけ。
import type { AffAffiliate, GfCreator, GfPayeeStatus, GfPlatform, GfSns, Loadable } from "../../../../types/gifting";
import { affiliateByInfluencer, toHalfWidth } from "../../../../lib/giftingRules";
import type { GfTone } from "../../ui/GfUi";

export function errMsg(e: unknown): string {
  return e instanceof Error && e.message ? e.message : "不明なエラーが発生しました";
}

/** 口座状態 → タグ（登録済=ok / 確認中=caution / 未登録=warn） */
export function payeeTag(s: GfPayeeStatus): { tone: GfTone; label: string } {
  switch (s) {
    case "registered":
      return { tone: "ok", label: "登録済" };
    case "pending":
      return { tone: "caution", label: "確認中" };
    default:
      return { tone: "warn", label: "未登録" };
  }
}

/** 指定媒体の SNS（複数あれば is_primary→フォロワー最大） */
export function snsOfPlatform<T extends Pick<GfSns, "platform" | "is_primary" | "follower_count">>(
  sns: T[],
  platform: GfPlatform
): T | null {
  const list = sns.filter((s) => s.platform === platform);
  if (!list.length) return null;
  return [...list].sort((a, b) => b.is_primary - a.is_primary || (b.follower_count ?? -1) - (a.follower_count ?? -1))[0];
}

/** affiliate（取得成功時のみ）を influencer id で引く Map。未取得なら空 */
export function affMapOf(l: Loadable<AffAffiliate[]>): Map<string, AffAffiliate> {
  return l.status === "ok" ? affiliateByInfluencer(l.data) : new Map();
}

export function creatorMap(creators: GfCreator[]): Map<string, GfCreator> {
  return new Map(creators.map((c) => [c.id, c]));
}

/**
 * フォロワー数入力 → 数値。空は null、不正は NaN。'12.4万' / '12,400' / '１２４００' を受ける。
 */
export function parseCount(s: string): number | null {
  const t = toHalfWidth(s).replace(/[,\s]/g, "");
  if (!t) return null;
  const m = t.match(/^(\d+(?:\.\d+)?)(万)?$/);
  if (!m) return Number.NaN;
  const n = Number(m[1]) * (m[2] ? 10_000 : 1);
  return Math.round(n);
}

/** 'YYYY-MM-DD' → 'YYYY/MM/DD' */
export function ymdSlash(s: string): string {
  return s.replace(/-/g, "/");
}

/** '先頭の @ を外す'（handle は @ 無しで保存する） */
export function stripAt(handle: string): string {
  return handle.trim().replace(/^[@＠]+/, "");
}
